import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { useQuery } from "react-query";




const fetchDdpcrById = async (plateId) => {
    const headerConfig = setHeaders();


    const { data } = await axios
        .get(`${config.ENDPOINTS["datalake"]}/list/ddpcr/${plateId}`, {
            headers: headerConfig
        });

    return data;
};

export default function useFetchDdpcrByPalteId(plateId) {
    return useQuery(["ddpcrById", plateId], () => fetchDdpcrById(plateId), {

        onSuccess: (data) => {
            //console.log({ data });
        },
        onError: (error) => {
            console.log({ error });
        }
    });
}
